const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, label, [role="button"]'

export default {
  methods: {
    openGroupPreview({ row, event }) {
      if (!row || !row.id) return
      if (event && event.target && event.target.closest(INTERACTIVE_SELECTOR)) return
      this.$emit('open-preview', {
        groupId: row.id,
        triggerElement: event && event.currentTarget,
      })
    },
  },
}
